// require("./chunk/_polyfills.js");

// import { viewport, debounce } from "./chunk/_utils.js";
// import "./chunk/mdc_topAppBar.js";
import { filterInputUpdate, filterNodesUpdate } from "./chunk/filter.js";
import { video_hls } from "./chunk/video.js";
video_hls()
// import "./chunk/video.js";

/**
 * MDC Button
 *
 */
import { MDCRipple } from "@material/ripple";
const filterInput = document.querySelectorAll(".categorie_filter .mdc-button");
const filterNodes = document.querySelectorAll("[data-categories]");
[...filterInput].forEach((button) => {
  const buttonRipple = new MDCRipple(button);

  button.addEventListener("click", (e) => {
    const filterQuery = e.target.parentNode.dataset?.filter;
    filterNodesUpdate(filterQuery, filterNodes);
    filterInputUpdate(filterQuery, filterInput);
  });
});

// const buttonRipple = new MDCRipple(document.querySelector('.mdc-button'));

/**
 * MDC Form
 *
 */
// import { MDCTextField } from "@material/textfield";
// const mdcTextFieldEl = document.querySelectorAll(".mdc-text-field");
// if (mdcTextFieldEl) {
//   [...mdcTextFieldEl].forEach((element) => {
//     const textField = new MDCTextField(element);
//   });
// }

/**
 * MDCTopAppBar
 */
//  import { MDCTopAppBar } from "@material/top-app-bar";
//  import { numbers } from "@material/top-app-bar/constants";
// const manageTopAppBar = () => {
//   console.log(viewport);

//   numbers.MAX_TOP_APP_BAR_HEIGHT = 200;
//   const topAppBarElement = document.querySelector(".mdc-top-app-bar");
//   const topAppBar = new MDCTopAppBar(topAppBarElement);
// };

/**
 * Video
 */
// import * as basicLightbox from "basiclightbox";
// const videos = document.querySelectorAll("a[data-video-id]");
// let instance;

// [...videos].forEach(openModal);

// function openModal(video) {
//   const youTubeId = video.getAttribute("data-video-id");

//   video.onclick = (e) => {
//     e.preventDefault();
//     instance = basicLightbox.create(`
//     <div class="modal">
//       <div class="youtube_wrapper">
//         <iframe src="https://www.youtube-nocookie.com/embed/${youTubeId}?controls=1&nocookie=true&autoplay=1&modestbranding=1&playsinline=0"  frameborder="0"></iframe>
//       </div>
//     </div>  
//     `);
//     instance.show();
//   };
// }

// //detect Escape key press
// document.addEventListener("keydown", function (event) {
//   if (event.keyCode === 27 && instance) {
//     instance.close();
//   }
// });

/**
 * Flickity
 */
// import Flickity from "flickity";

// const carousel = document.querySelector(".carousel");
// const corouselOptions = {
//   // options
//   // cellAlign: 'left',
//   // imagesLoaded: true,
//   percentPosition: false,
//   // setGallerySize: false,
//   prevNextButtons: true,
//   pageDots: false,
//   wrapAround: true, // infinite

//   autoPlay: 6000,
//   pauseAutoPlayOnHover: false,

//   adaptiveHeight: true,
//   arrowShape: {
//     x0: 25,
//     x1: 60,
//     y1: 50,
//     x2: 65,
//     y2: 50,
//     x3: 30,
//   },
// };

// if (carousel) {
//   const flkty = new Flickity(carousel, corouselOptions);
// }
